export const UNIT_DISPLAY_RANGES = {
  label_px: { min: 9, max: 18, step: 1 },
  speed_px: { min: 7, max: 14, step: 1 },
  icon_scale: { min: 0.75, max: 3, step: 0.05 },
  card_opacity: { min: 0.4, max: 1, step: 0.05 },
} as const satisfies Record<string, { min: number; max: number; step: number }>;

export const NAME_MODES = { full: "full", unit: "unit", none: "none" } as const satisfies Record<string, string>;

export const LABEL_STYLES = { card: "card", halo: "halo" } as const satisfies Record<string, string>;

export type RangeKey = keyof typeof UNIT_DISPLAY_RANGES;
export type NameMode = keyof typeof NAME_MODES;
export type LabelStyle = keyof typeof LABEL_STYLES;

export interface UnitDisplaySettings {
  label_px: number;
  speed_px: number;
  show_speed: boolean;
  name_mode: NameMode;
  label_style: LabelStyle;
  card_opacity: number;
  status_dot: boolean;
  icon_scale: number;
}
